module.exports = __webpack_public_path__ + "img/Swift.edfc7064.jpg";